import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditMPConfigContext from 'contexts/EditMPConfigContext';
import MPConfigForm from 'forms/MPConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedMPConfig } = React.useContext(EditMPConfigContext);
  if (!selectedMPConfig) {
    history.push('/private/admin/payments/mercado-pago');
    return <></>;
  }

  return (
    <div>
      <MPConfigForm config={selectedMPConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
